import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { downloadDocument, printDocument } from '../../../../store/documents/documents.actions';
import { printPickList } from '../../../../store/printing/print.actions';
import { usePrintSettings } from '../../core/hooks';
import { DocumentType } from '../../../../enums/document-type';
import { usePicklistsFeatureGate } from '../../../../feature-gates/use-picklists-feature-gate';

export const usePickList = ({ fulfillmentPlanIds }) => {
  const dispatch = useDispatch();
  const printSettings = usePrintSettings(DocumentType.PickList.printSettingKey);
  const { isFeatureEnabled } = usePicklistsFeatureGate();

  const onClick = useCallback(() => {
    dispatch(printPickList(fulfillmentPlanIds));
  }, [dispatch, fulfillmentPlanIds]);

  const onDownload = useCallback(() => {
    dispatch(downloadDocument(DocumentType.PickList, fulfillmentPlanIds));
  }, [dispatch, fulfillmentPlanIds]);

  const onPrint = useCallback(() => {
    dispatch(printDocument(DocumentType.PickList, fulfillmentPlanIds, printSettings));
  }, [dispatch, fulfillmentPlanIds, printSettings]);

  return useMemo(
    () => ({
      onClick,
      onDownload,
      onPrint,
      isDisabled: !isFeatureEnabled || fulfillmentPlanIds.length === 0,
      isFeatureEnabled,
    }),
    [fulfillmentPlanIds.length, isFeatureEnabled, onClick, onDownload, onPrint],
  );
};
